import Vue from "vue";
import Router from "vue-router";
import user from "@/store/user.js";

const HomePage = () => import("@/views/Home.vue");

const List = () => import("@/views/list/Index.vue");
const Detail = () => import("@/views/list/Detail.vue");
const EditProduct = () => import("@/views/list/EditProduct.vue");
const AdminProduct = () => import("@/views/list/AdminProduct.vue");

const Material = () => import("@/views/pages/Material.vue");
const Contact = () => import("@/views/pages/Contact.vue");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");

//User
const Login = () => import("@/views/user/Login");
const ForgotPassword = () => import("@/views/user/ForgotPassword");
const ResetPassword = () => import("@/views/user/ResetPassword");
const ChangePassword = () => import("@/views/user/ChangePasswordNew");

// Collection
const MyCollection = () => import("@/views/collection/MyCollection.vue");
const SavedCollections = () => import("@/views/collection/SavedCollection.vue");

Vue.use(Router);

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage
    },
    {
      path: "/admin",
      name: "Admin",
      component: AdminProduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/list",
      name: "List",
      component: List
    },
    {
      path: "/detail-new",
      name: "Detail",
      component: Detail
    },
    {
      path: "/saved-collections",
      name: "SavedCollections",
      component: SavedCollections,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/my-collection/:cartId*",
      name: "MyCollection",
      component: MyCollection,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit",
      name: "EditProduct",
      component: EditProduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/materials",
      name: "Materials",
      component: Material
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: ResetPassword
    },
    {
      path: "/change-password",
      name: "ChangePassword",
      component: ChangePassword
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (user.getters.authUser) {
      next();
      return;
    }

    let query = to.fullPath ? { returnUrl: to.fullPath } : null;
    next({ name: "Login", query });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js